import * as Yup from 'yup';
import { ResearchQuery } from '@models';
import { ResearchQueryType } from '@enums';

export function useValidationSchema() {
  return Yup.object<ResearchQuery>().shape({
    query: Yup.string().nullable().required(),
    ipAddress: Yup.string().nullable().required(),
    type: Yup.mixed<ResearchQueryType>().nullable().required(),
    success: Yup.boolean(),
  });
}
